import { render, staticRenderFns } from "./TransactionActivityCredit.vue?vue&type=template&id=3b52caf9&"
import script from "./TransactionActivityCredit.vue?vue&type=script&lang=ts&"
export * from "./TransactionActivityCredit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports